import "./commonBanner.css";

const bannerText = [
  "13 Years of Powering the Future of AI.",
  "Powering AI Innovation.",
  "Delivering Model-Ready Data.",
  "Enabling Global Business.",
];

function MarqueeGroup({ copy }) {
  return (
    <div className="common-banner__group" aria-hidden="true">
      {bannerText.map((text, index) => (
        <span className="common-banner__item" key={`${copy}-${text}`}>
          <span
            className={`common-banner__text ${
              index === 1
                ? "common-banner__text--accent"
                : "common-banner__text--dark"
            }`}
          >
            {text}
          </span>
          <span className="common-banner__separator" />
        </span>
      ))}
    </div>
  );
}

export default function CommonBanner() {
  return (
    <section className="common-banner" aria-label="Qualitas Global">
      <h2 className="common-banner__accessible">
        Powering AI Innovation. Delivering Model-Ready Data. Enabling Global
        Business.
      </h2>

      <div className="common-banner__marquee">
        <div className="common-banner__track">
          <MarqueeGroup copy="first" />
          <MarqueeGroup copy="second" />
        </div>
      </div>
    </section>
  );
}
